import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, StatusComponent } from "../../../common/component/Index";
import Post from './../../../../../models/Post';
import { withTranslation } from "react-i18next";
import { Icon, Menu, Tooltip } from 'antd';
import Ripple from '../../../common/component/Ripple';
import { PATHS, TRANSLATE_LANGUAGE } from '../../../../../constants/Define';
import moment from "moment";
import Modal from '../../../common/component/Modal';
import Dropdown from '../../../common/component/Dropdown';
import { FlagIcons } from '../../../common/component/TranslateButton';
import { toArray } from 'lodash'
import EllipsisText from '../../../common/component/EllipsisText';
const ListCols = ['title', 'source', 'order', 'createdDate', 'isAvailable', 'categories', 'translations'];
const ModelFields = Object.getOwnPropertyNames(new Post());
class PostList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                title: {
                    key: 'title',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={400}
                        overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                source: {
                    key: 'source',
                    width: 150,
                    render: (text, record) => {
                        if (record.source === 'vpt') {
                            return 'Vinpearl Travel';
                        }
                        if (record.source === 'vpg') {
                            return 'Vinpearl Golf';
                        }
                        return text;
                    },
                    filters: [
                        { value: 'vpt', text: 'Vinpearl Travel' },
                        { value: 'vpg', text: 'Vinpearl Golf' },
                    ],
                    filterMultiple: false,
                },
                createdDate: {
                    width: 150,
                    key: 'createdDate',
                    align: 'right',
                    render: (date, record) => moment(moment.utc(date).toDate().toJSON()).format('DD-MM-YYYY HH:mm'),
                },
                isAvailable: {
                    width: 100,
                    key: 'active',
                    render: (isAvailable) => (
                        <StatusComponent color={isAvailable ? 'green' : 'red'}
                            label={isAvailable ? this.props.t('item.post.available') : this.props.t('item.post.unAvailable')} />
                    )
                },
                categories: {
                    width: 100,
                    key: 'type',
                    render: (categories, record) => categories.map(i => i.name).join(', '),
                },
                translations: {
                    key: 'languageCode',
                    filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                        value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                    })),
                    filterMultiple: false,
                    width: 120,
                    render: (text, record) => <FlagIcons languages={record.translations} />,
                },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
        };
    }

    render() {
        const { loading, pagination, posts } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <ListComponent
                tableKey="post-list"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(posts || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'post'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
            />
        );
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeItem = () => {
            return this.props.onDeletePost && this.props.onDeletePost(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.post.title_page`)),
                content: item.title,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeItem,
            });
        };
        return (
            <Fragment>

                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.POST.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }

                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }


}

export default withTranslation()(PostList);
